/**
 * 「退会の手続き中」の案内（026）。ログイン・会員登録の画面で、退会中のメールだったときに出す。
 *   いつまで戻せるか・メールのリンクを押すこと・届いていなければ送り直す
 */
import { ACCOUNT_MSG } from "@genbaryoku/contract";
import { useState } from "react";
import { api, messageOf } from "../api.js";

import { ymdShort } from "../lib/dates.js";
/** 「26/11/05」（#320 ★8＝画面の年月日は年2桁） */
const jdate = (iso: string | null | undefined) => ymdShort(iso) || null;

export function ClosedNotice({ email, purgeAfter, justClosed = false }: { email: string; purgeAfter: string | null | undefined; justClosed?: boolean }) {
  const [sent, setSent] = useState<string | undefined>();
  const [busy, setBusy] = useState(false);
  const until = jdate(purgeAfter);
  const resend = async () => {
    setBusy(true);
    try {
      await api("POST", "/account/resend-reopen", { email });
      setSent(ACCOUNT_MSG.reopenSent);
    } catch (e) {
      setSent(messageOf(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="notice" role="status" data-testid="closed-notice" style={{ border: "1px solid var(--frame)", background: "var(--warn)", padding: "12px 14px", lineHeight: 1.6 }}>
      <b>{justClosed ? "退会を受け付けました。" : "このメールアドレスは退会の手続き中です。"}</b>
      <div>
        {justClosed ? `${email} に、元に戻すためのメールを送りました。` : ""}
        {until ? `${until} までなら、メールの「元に戻す」リンクを押すと今までどおり使えます。それを過ぎるとデータは消えます。` : "退会のときに届いたメールの「元に戻す」リンクを押すと、今までどおり使えます。"}
      </div>
      <div className="row" style={{ marginTop: 8, alignItems: "center", gap: 10 }}>
        <button type="button" className="small" disabled={busy} onClick={() => void resend()}>
          復元メール再送
        </button>
        {sent ? <span className="hint">{sent}</span> : null}
      </div>
    </div>
  );
}
